import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintKekuranganUangMuka = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocKekuranganUangMuka = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            padding: "5px 0",
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>SURAT PENGAKUAN KEKURANGAN BAYAR UANG MUKA</div>
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>Saya yang bertanda tangan di bawah ini:</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tgl Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "20px" }}>Dengan ini menyatakan bahwa saya telah melakukan pembayaran uang muka sebesar Rp. Dan masih memiliki kekurangan bayar uang muka sebesar Rp. Untuk pembelian rumah sejahtera tapak kepada :</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr style={{ fontWeight: "bold" }}>
                <td style={{ verticalAlign: "top", width: "240px" }}>Nama Pengembang</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{companyName ?? "-"}</td>
              </tr>
              <tr style={{ fontWeight: "bold" }}>
                <td>Alamat Rumah Yang Dibeli</td>
                <td>:</td>
                <td> {item.sales_branch?.branch_address[0]?.description}</td>
              </tr>
              <tr>
                <td>Harga Jual Rumah</td>
                <td>:</td>
                <td>{currencyFormat(item.sales_detail[0]?.amount)}</td>
              </tr>
              <tr>
                <td>Besaran Uang Muka</td>
                <td>:</td>
                <td>{currencyFormat(item.sales_detail[0]?.price_dp)}</td>
              </tr>
              <tr>
                <td>Bank Pelaksana</td>
                <td>:</td>
                <td>{"Bank Tabungan Negara ( Persero )"}</td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "15px" }}>Jika permohonan SBUM saya tidak disetujui,maka saya bersedia untuk membayar kekurangan uang muka pembelian rumah sejahtera tapak menggunakan dana sendiri.</p>

          <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terimakasih.</p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>Menyetujui</div>
            </div>
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>Bogor, ................................</div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                  Materai
                  <br />
                  10.000,-
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                Angga Budi Kusuma
                <br />
                <span style={{ fontWeight: "normal" }}>Direktur utama</span>
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                {item.sls_appl?.name ?? "-"} <br />
                <span style={{ fontWeight: "normal" }}>Pemohon</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
